/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArrayUnmappedUserInfo,
  CacheStatus,
  ConnectResponse,
  ConnectionInfo,
  DisconnectResponse,
  Email,
  FlowRequest,
  FlowsResponse,
  GongUserStatisticsResponse,
  MapString,
  PaginatedResultUnmappedUserInfo,
  UserInfo,
  UserMappingReplaceRequest,
  UsersInfoResponse,
  WorkspacesResponse,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "gong";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags OAuth
   * @name CallbackForOAuthCalls
   * @request GET:/v1/public/oauth/callback
   */
  callbackForOAuthCalls = (
    query: {
      /** @minLength 1 */
      code: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for callbackForOAuthCalls */
  callbackForOAuthCallsPathGetter = (query: {
    /** @minLength 1 */
    code: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * No description
   *
   * @tags Connection
   * @name ConnectionInfo
   * @request GET:/v1/tenant/{tenantId}/connection
   * @secure
   */
  connectionInfo = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ConnectionInfo,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connection`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectionInfo */
  connectionInfoPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/connection`);

  /**
   * No description
   *
   * @tags Connection
   * @name Connect
   * @request POST:/v1/tenant/{tenantId}/connection
   * @secure
   */
  connect = (
    tenantId: string,
    query: {
      redirect: string;
      /**
       * overrides the default scopes with the provided ones
       * @example ["api:users:read","api:meetings:user:create"]
       */
      scopes?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connection`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connect */
  connectPathGetter = (
    tenantId: string,
    query: {
      redirect: string;
      /**
       * overrides the default scopes with the provided ones
       * @example ["api:users:read","api:meetings:user:create"]
       */
      scopes?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/connection`, query);

  /**
   * No description
   *
   * @tags Connection
   * @name Disconnect
   * @request DELETE:/v1/tenant/{tenantId}/connection
   * @secure
   */
  disconnect = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      DisconnectResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connection`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnect */
  disconnectPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/connection`);

  /**
   * No description
   *
   * @tags Users
   * @name GetAllUsers
   * @request GET:/v1/tenant/{tenantId}/users/all
   * @secure
   */
  getAllUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      UsersInfoResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllUsers */
  getAllUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/all`);

  /**
   * No description
   *
   * @tags Users
   * @name GetUsers
   * @request GET:/v1/tenant/{tenantId}/user/{userId}
   * @secure
   */
  getUsers = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      UserInfo,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsers */
  getUsersPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`);

  /**
   * No description
   *
   * @tags Users
   * @name LoadAllGongUsers
   * @request POST:/v1/tenant/{tenantId}/users/gong/loadAll
   * @secure
   */
  loadAllGongUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/loadAll`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for loadAllGongUsers */
  loadAllGongUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/gong/loadAll`);

  /**
   * No description
   *
   * @tags Users
   * @name IsValidGongUsersLoading
   * @request GET:/v1/tenant/{tenantId}/users/gong/isLoading
   * @secure
   */
  isValidGongUsersLoading = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      boolean,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/isLoading`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for isValidGongUsersLoading */
  isValidGongUsersLoadingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/gong/isLoading`);

  /**
   * No description
   *
   * @tags Users
   * @name FetchAllGongUsers
   * @request GET:/v1/tenant/{tenantId}/users/gong/all
   * @secure
   */
  fetchAllGongUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ArrayUnmappedUserInfo,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllGongUsers */
  fetchAllGongUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/gong/all`);

  /**
   * @description List gong users paginated
   *
   * @name FetchAllGongUsersPaginated
   * @request GET:/v1/tenant/{tenantId}/users/paginated
   * @secure
   */
  fetchAllGongUsersPaginated = (
    tenantId: string,
    query?: {
      /** search string in email or email aliases */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUnmappedUserInfo,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/paginated`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllGongUsersPaginated */
  fetchAllGongUsersPaginatedPathGetter = (
    tenantId: string,
    query?: {
      /** search string in email or email aliases */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users/paginated`, query);

  /**
   * No description
   *
   * @tags Users
   * @name IsGongUsersLoading
   * @request GET:/v1/tenant/{tenantId}/users/gong/isGongUsersLoading
   * @secure
   */
  isGongUsersLoading = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      boolean,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/isGongUsersLoading`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for isGongUsersLoading */
  isGongUsersLoadingPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/gong/isGongUsersLoading`);

  /**
   * No description
   *
   * @tags Users
   * @name CacheStatus
   * @request GET:/v1/tenant/{tenantId}/users/gong/caches
   * @secure
   */
  cacheStatus = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      CacheStatus,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/caches`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cacheStatus */
  cacheStatusPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users/gong/caches`);

  /**
   * No description
   *
   * @tags Users
   * @name GetGongUserStatistics
   * @request GET:/v1/tenant/{tenantId}/users/gong/statistics
   * @secure
   */
  getGongUserStatistics = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      GongUserStatisticsResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/gong/statistics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getGongUserStatistics */
  getGongUserStatisticsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/gong/statistics`);

  /**
   * No description
   *
   * @tags Users
   * @name ReplaceUsers
   * @request POST:/v1/tenant/{tenantId}/users
   * @secure
   */
  replaceUsers = (tenantId: string, data: UserMappingReplaceRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceUsers */
  replaceUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/users`);

  /**
   * No description
   *
   * @tags Users
   * @name RemapUsers
   * @request POST:/v1/tenant/{tenantId}/remap-users
   * @secure
   */
  remapUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      object,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/remap-users`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for remapUsers */
  remapUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/remap-users`);

  /**
   * No description
   *
   * @tags Flows
   * @name GetAllFlows
   * @request POST:/v1/tenant/{tenantId}/flows
   * @secure
   */
  getAllFlows = (tenantId: string, data: FlowRequest, params: RequestParams = {}) =>
    this.request<
      FlowsResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/flows`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllFlows */
  getAllFlowsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/flows`);

  /**
   * No description
   *
   * @tags Workspaces
   * @name GetAllWorkspaces
   * @request GET:/v1/tenant/{tenantId}/workspaces/all
   * @secure
   */
  getAllWorkspaces = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WorkspacesResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspaces/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAllWorkspaces */
  getAllWorkspacesPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/workspaces/all`);

  /**
   * @description Webhook endpoint to receive notifications from Gong about call events
   *
   * @name GongWebhook
   * @request POST:/v1/public/tenant/{tenantId}/webhook/call
   */
  gongWebhook = (tenantId: string, data: object, params: RequestParams = {}) =>
    this.request<void, Email>({
      path: `/v1/public/tenant/${tenantId}/webhook/call`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for gongWebhook */
  gongWebhookPathGetter = (tenantId: string) => this.getServicePath(`/v1/public/tenant/${tenantId}/webhook/call`);
}
